var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoticeBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9486 7.80005C10.9486 7.15572 11.4709 6.63338 12.1153 6.63338C12.7596 6.63338 13.2819 7.15572 13.2819 7.80005C13.2819 8.44438 12.7596 8.96671 12.1153 8.96671C11.4709 8.96671 10.9486 8.44438 10.9486 7.80005ZM12.1153 18.3C12.7569 18.3 13.2819 17.775 13.2819 17.1334V12.4667C13.2819 11.825 12.7569 11.3 12.1153 11.3C11.4736 11.3 10.9486 11.825 10.9486 12.4667V17.1334C10.9486 17.775 11.4736 18.3 12.1153 18.3ZM12.1153 0.800049C5.67528 0.800049 0.448608 6.02671 0.448608 12.4667C0.448608 18.9067 5.67528 24.1334 12.1153 24.1334C18.5553 24.1334 23.7819 18.9067 23.7819 12.4667C23.7819 6.02671 18.5553 0.800049 12.1153 0.800049ZM12.1153 21.8C6.97028 21.8 2.53633 17.6117 2.53633 12.4667C2.53633 7.32171 6.97028 3.13338 12.1153 3.13338C17.2603 3.13338 21.817 7.32171 21.817 12.4667C21.817 17.6117 17.2603 21.8 12.1153 21.8Z",
    fill: "#3399FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBlueIcon);
export default __webpack_public_path__ + "static/media/notice-blue-icon.5f75f5fe.svg";
export { ForwardRef as ReactComponent };